import { C } from '../theme'
import { grp } from '../lib/format'
import type { Snapshot } from '../types'

export function Header({ snap }: { snap: Snapshot }) {
  // Блок старше 15 секунд — красным: три числа пула согласованы только внутри
  // одного запиненного блока, и вне его они уже не про одну и ту же позицию.
  const blockStale = snap.blockAgeSec > 15

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
        rowGap: 6,
        borderBottom: `1px solid ${C.border}`,
        paddingBottom: 14,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
        <img src="/mark.svg" alt="" width={18} height={18} style={{ display: 'block' }} />
        <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: '.2em' }}>LIQUORICE</span>
        <span style={{ fontSize: 14, color: C.muted, whiteSpace: 'nowrap' }}>
          {snap.algo} · ETH mainnet
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          fontSize: 14,
          color: C.muted2,
          flexWrap: 'wrap',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: C.pos,
              display: 'block',
            }}
          />
          live {snap.uptimeLabel}
        </span>
        <span data-hide style={{ whiteSpace: 'nowrap', color: blockStale ? C.neg : C.muted2 }}>
          block {grp(snap.blockNumber)} · {snap.blockAgeSec} s
        </span>
        <span data-hide style={{ whiteSpace: 'nowrap' }}>
          ws {snap.wsUptimeLabel}
        </span>
      </div>
    </div>
  )
}
